<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                                <strong>{{$t('acceptedRequest')}}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: end">

                                <CButton
                                        class="mr-1 ml-1"
                                        size="sm"
                                        :disabled="!id_checkbox_items.length"
                                        color="secondary"
                                        @click="accept_factor()"
                                >{{ $t("buttons.submit") }}
                                </CButton>

                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody class="mb-3">
                        <CRow>
                            <CCol col="3">
                                <date-picker

                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>
                            <CCol col="3">

                                <CSelect
                                        :placeholder="$t('RequestType')"
                                        :options="selectTypes"
                                />
                            </CCol>
                            <CCol col="3">

                                <CSelect
                                        :options="[{label:$t('all'),value:0},{label:$t('openedOrder'),value:1}]"
                                />
                            </CCol>
                        </CRow>
                        <CDataTableFixed
                                :items="items_buy"
                                :fields="factor_product_fields"
                                column-filter
                                :items-per-page="20"
                                hover
                                height="300px"
                                striped
                                border
                                sorter
                                pagination
                        >
                            <template #row="{item,index}">

                                <td>
                                    <p >{{ index + 1 }}</p>

                                </td>

                            </template>

                            <template #qty="{item,index}">

                                <td v-if="!item.orderCode">
                                    <CInput class="m-0 p-0" v-model="items_buy[index].qty"/>

                                </td>
                                <td v-else>
                                    <p style="text-align: center">{{item.qty}}</p>

                                </td>


                            </template>

                            <template #price="{item,index}">
                                <td v-if="!item.orderCode">
                                    <CInput class="m-0 p-0" v-model="items_buy[index].price"/>
                                </td>
                                <td v-else>
                                    <p style="text-align: right">{{get_currency(item.price)}}</p>
                                </td>
                            </template>
                            <template #vat="{item,index}">
                                <td v-if="!item.orderCode">
                                    <CInput class="m-0 p-0" v-model="items_buy[index].vat"/>
                                </td>
                                <td v-else>
                                   <p style="text-align: right"> {{get_currency(item.vat)}}</p>
                                </td>
                            </template>
                            <template #discount="{item,index}">
                                <td v-if="!item.orderCode">
                                    <CInput class="m-0 p-0" v-model="items_buy[index].discount"/>
                                </td>
                                <td v-else>
                                    <p style="text-align: right"> {{get_currency(item.discount)}}</p>
                                </td>
                            </template>

                            <template #code_number="{item}">

                                <td v-if="!item.orderCode">
                                    <p></p>

                                </td>
                                <td v-else>
                                    <p>{{ item.orderCode }}</p>

                                </td>

                            </template>

                            <template #supplierName="{item,index}">
                                <td v-if="!item.orderCode">
                                    <treeselect
                                            v-model="items_buy[index].supplierId"
                                            :async="suuplier_sync"
                                            :options="supplier_list"
                                            :load-options="load_persons"
                                            :appendToBody="true"
                                            :placeholder="$t('supplier')"
                                            :normalizer="normalizer_persons"
                                    />
                                </td>
                                <td v-else>
                                    {{item.supplierName}}
                                </td>

                            </template>
                            <template #select-header="{item}">
                                <input type="checkbox" v-model="check_all_exit"
                                />
                            </template>
                            <template #select="{item}">
                                <td v-if="!item.orderCode">
                                    <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                                           :value="item.id"/>
                                </td>
                            </template>


                        </CDataTableFixed>

                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>

    </div>

</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'
    import Vue from "vue";

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                // show_document: 'test-dynamic',
                printed_doc_id: 0,
                name: '',
                show_factor_detail: false,
                check_all_exit: false,

                start_date: '',
                end_date: '',
                submit_refer: 0,
                refer_person: null,
                selected_template: 0,
                id_checkbox_items: [],
                item_sell_array: [],
                items_buy: [],
                selected_factor: [],
                selectTypes: [
                    {
                        value: 1,
                        label: this.$t('sidebars.administrative')
                    },
                    {
                        value: 3,
                        label: this.$t('supplyInventory')
                    }, {
                        value: 3,
                        label: this.$t('consumed')
                    },
                ],
                factor_product_fields: [

                    {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
                    {key: 'productName', label: this.$t('components.productName'), _style: 'width:15%'},
                    {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%'},
                    {key: 'price', label: this.$t('tables.amount') , _style: 'width:7%'},
                    {key: 'vat', label: this.$t('tables.tax') , _style: 'width:7%'},
                    {key: 'discount', label: this.$t('tables.off') , _style: 'width:7%'},
                    {key: 'supplierName', label: this.$t('supplierName'), _style: 'width:12%'},
                    {key: 'code_number', label: this.$t('orderId'), _style: 'width:7%'},
                    {key: 'masterCode', label: this.$t('orderedId'), _style: 'width:7%'},

                    {key: 'select', label: "", _style: 'width:3%', filter: false},

                ],
                fields: [
                    {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
                    {key: 'recId', label: this.$t('orderId'), _style: 'width:10%'},

                    {key: 'createdAt', label: this.$t('requestDate'), _style: 'width:15%'},
                    {key: 'createdAt', label: this.$t('departmanName'), _style: 'width:15%'},
                    // {key: 'انبار', _style: 'width:10%'},
                    {key: 'price', label: this.$t('tables.amount'), _style: 'width:10%'},
                    // {key: 'customer', label: this.$t('tables.customer'), _style: 'width:20%'},
                    {key: 'user', label: this.$t('tables.user'), _style: 'width:15%'},
                    // {key: 'toziKonande', label: this.$t('tables.driver'), _style: 'width:15%'},

                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
                    // {key: 'select', label: this.$t('tables.select'),},

                ],

                table_clicks: 0,
                table_clicks_timer: null,
                details: [],
                supplier_list: [],
                suuplier_sync:true,
                status_form: 0,
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', true);
                            formData.append('IsWorker', false);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                            })
                                .catch(function (error) {

                                    console.log(error);
                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode +" "+ node.userName ,
                    }
                },

            }
        }, mounted() {

            this.start_date = this.get_day_before_today(1);
            this.end_date = this.get_today();

            this.$root.root_validate_errors = [];

            this.get_all_data();
            bus.$on('update_orders', (data) => {
                this.get_all_data()
            });

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            'check_all_exit': function () {
                if (this.check_all_exit) {
                    this.id_checkbox_items = [];

                    this.items_buy.forEach((val) => {
                        this.id_checkbox_items.push(val.id);
                    });
                } else {
                    this.id_checkbox_items = [];
                }
            },
            '$route.params.person_id': function () {
                // this.get_all_data();
            },
            'start_date': function () {
                this.get_all_data();
            },
            'end_date': function () {
                this.get_all_data();
            }
        },
        methods: {
            get_all_data() {
                this.get_lists_buy();

            },
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.selected_factor = item.details;
                    this.show_factor_detail = true;
                    this.status_form = item.masterId;
                    this.table_clicks = 0

                }

            },
            accept_factor() {
                var self = this;

                const formData = new FormData();
                var url = "AddPurchaseOrder";
                formData.append("StatusId", 1);

                var details = [];
                var validate = true;
                this.id_checkbox_items.forEach((val) => {

                    var item = this.items_buy.filter(x => x.id == val)[0]
                    console.log(item);
                    if (item.price == 0 || item.supplierId == null) {
                        this.$root.modal_component.show_validate_errors(["تمامی اطلاعات را وارد کنید"])
                        validate = false;
                    }


                    if (item.summary == null) {
                        item.summary = '';
                    }
                    var total_price = (item.qty * item.price)+parseFloat(item.vat) - parseFloat(item.discount);
                    var obj = {
                        ProductId: item.productId,
                        Qty: item.qty,
                        Price: item.price,
                        Vat: item.vat,
                        Discount: item.discount,
                        TotalPrice: parseFloat(total_price).toFixed(2),
                        Summary: item.summary,
                        SupplierId: item.supplierId,
                        RequestMasterId: item.masterId,
                        RequestDetailId: item.id
                    }
                    details.push(obj);
                });
                if (validate == false) {
                    return false;
                }
                formData.append("RequestMasterId", self.status_form);
                var model = {Details: details}
                formData.append("input", JSON.stringify(model));

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {
                        self.get_lists_buy();
                        self.$root.modal_component.show_api_response_modals(response);
                        bus.$emit("update_orders", "");

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });


            },
            get_lists_buy() {
                var self = this;


                const formData = new FormData();
                var url = "GetAcceptPurchaseReq";
                formData.append("Id", 1);
                if (self.$route.params.person_id != null) {
                    formData.append("PersonId", self.$route.params.person_id);

                } else {
                    formData.append("PersonId", 0);
                }
                formData.append("FirstDate", self.start_date);
                formData.append("SecondDate", self.end_date);

                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {
                        // self.items_buy = content_data.data.map((item, row_id) => {
                        //   return {...item, row_id}
                        // });
                        var factors = content_data.data;
                        // factors = factors.filter(x => x.isAccept == 1)
                        self.items_buy = [];
                        self.suuplier_sync = false;

                        factors.forEach((val) => {
                            // console.log(val);
                            // val.details.forEach((val2) => {
                            // console.log(val2);
                          if(val.supplierId==0) {
                            val.supplierId = null;
                          }
                            self.supplier_list.push({personCode: "",userName: val.supplierName, userId: val.supplierId})
                            self.items_buy.push(val)
                            // });
                        });

                        setTimeout(() => {
                              self.suuplier_sync = true;
                        }, 500);

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            Finalize(item) {
                var self = this;


                const formData = new FormData();

                var url = "AddFactorToFinal";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            send_to_customer(item) {
                var self = this;


                const formData = new FormData();

                var url = "SendFactorToTelegramBoth";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            goReturnDocument(item) {
                this.$router.push({
                    path: '/dashboard/documents/return/' + item.recId + "/false",
                    params: {passed_data: "salam hamidddd"}
                });
            },
            goShowDocument(item) {

                this.$router.push({path: '/dashboard/documents/show/' + item.recId});
            },
            goPrintDocument(item) {
                bus.$emit("print_confirm", item.recId);


            },
            AddRefer(item) {
                this.submit_refer = item.recId;
            },

            AddAllRefer() {
                this.submit_refer = -1;
                if (this.id_checkbox_items.length == 0) {
                    console.log("validate form is false" + this.validate_errors);
                    this.submit_refer = 0;

                }
            },

            insert_refer() {
                let self = this;

                if (this.submit_refer != -1) {


                    this.id_checkbox_items = [];
                } else {
                    if (this.id_checkbox_items.length == 0) {
                        console.log("validate form is false" + this.validate_errors);
                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        return true;
                    }

                }
                if (this.refer_person == null) {
                    console.log("validate form is false" + this.validate_errors);

                    return true;
                }
                let url;
                // if (this.status_form == 0) {
                url = "AddFactorRefer";
                // }
                if (this.submit_refer != -1) {
                    const formData = new FormData();

                    formData.append('PersonId', this.refer_person);

                    formData.append('MasterFactorId', this.submit_refer);
                    axios.post(url, formData, {}).then((res) => {



                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        self.refer_person = null;

                      self.$root.modal_component.show_api_response_modals(res);
                      self.get_all_data()
                    })
                        .catch(function (error) {

                            console.log(error);
                        });
                } else {
                    self.id_checkbox_items.forEach((val) => {

                        const formData = new FormData();

                        formData.append('PersonId', this.refer_person);

                        formData.append('MasterFactorId', val);
                        axios.post(url, formData, {}).then((res) => {



                        })
                            .catch(function (error) {

                                console.log(error);
                            });
                    });
                    self.id_checkbox_items = [];
                    self.submit_refer = 0;
                    self.id_checkbox_items = [];

                    self.refer_person = null;

                    this.get_all_data()
                }


            },

        },

    }

</script>
